import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_FIPS_CODE from './GetFipsCode.graphql';

export const useGetFipsCode = (options) =>
  useCustomQuery(GET_FIPS_CODE, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getFipsCode',
  });
